import classnames from 'classnames';
import React from 'react';

import '@eika/link-panel-style';
import { Polymorph } from '@eika/polymorph';

import { LinkCard } from './LinkCard';
import { LinkPanelAdvanced } from './LinkPanelAdvanced';
import { LinkPanelProps } from './LinkPanelTypes';
import { ListPanel } from './ListPanel';
import { Tags, PanelArrow, TextContent } from './components';
import useGenerateId from './hooks/useGenerateId';

const LinkPanel = ({
    isAdvanced,
    isInformation,
    isCard,
    cardIcon,
    icon,
    url,
    title,
    textOne,
    textTwo,
    textThree,
    tags,
    ariaLabel,
    advancedIcon,
    isList,
    className,
    as,
    ...rest
}: LinkPanelProps): JSX.Element => {
    const textContent = { title, textOne, textTwo, textThree };
    const sharedProps = { ...rest, ...textContent, isInformation, url, tags, ariaLabel, className, as };
    const hasTextContent = textOne || tags || textTwo || textThree;

    const labelId = useGenerateId();

    if (isAdvanced) {
        return <LinkPanelAdvanced icon={advancedIcon} {...sharedProps} />;
    }

    if (isCard && cardIcon) {
        return <LinkCard icon={cardIcon} {...sharedProps} />;
    }

    if (isList) {
        return <ListPanel {...sharedProps} />;
    }

    return (
        <Polymorph
            as={as}
            className={classnames(
                'sgw-link-panel',
                { information: isInformation },
                { 'align-center': !hasTextContent },
                className,
            )}
            aria-labelledby={labelId}
        >
            <a className="sgw-link-panel__link" href={url} aria-label={ariaLabel} {...rest}>
                <Tags tags={tags} />
                <TextContent id={labelId} {...textContent} />
                <PanelArrow icon={icon} />
            </a>
        </Polymorph>
    );
};

export default LinkPanel;
